import { UTF8_BOM } from './csv';

/**
 * Canonical CSV download.
 *
 * Replaces five near-identical hand-rolled copies of the same eight lines
 * (`useCsvParser.downloadTemplate`, `inventoryApi.downloadStockCsv`,
 * `Logs.downloadCsv`, `ErrorTable`, `BulkImportExpandedRow`). Centralising it
 * is what makes the BOM decision enforceable in one place instead of five.
 *
 * The BOM matters: Excel on Windows sniffs BOM-less UTF-8 as the system ANSI
 * codepage, so Chinese titles arrive as mojibake — unreadable for exactly the
 * operators this feature serves. Idempotent: content that already starts with
 * a BOM is not double-prefixed.
 */
export const downloadCsvFile = (content: string, filename: string): void => {
  const withBom = content.charCodeAt(0) === 0xfeff ? content : UTF8_BOM + content;
  downloadBlob(new Blob([withBom], { type: 'text/csv;charset=utf-8;' }), filename);
};

export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.display = 'none';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};
